<template>
  <div class="content">
    <div style="text-align: right" @click="()=>{ this.$router.back() }">返回</div>
    <div class="preview">
      <img class="preview_img" src="../../assets/layers1.jpg" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style scoped lang="scss">
  .content{
    width: 100%;
    padding: 20px 30px;
    box-sizing: border-box;
    .preview{
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .preview_img{
        width: 500px;
        height: 800px;
        border: 3px solid #f0f0f0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/Preview.vue